<template>
  <div>
    <!-- v-bind:isでタブインタフェースのコンポーネントを切り替えられる -->
    <component v-bind:is="layout()"></component>
  </div>
</template>

<script>
// レイアウトコンポーネントをインポート
import DefaultLayout from '/src/views/components/layout/DefaultLayout';
import LoginLayout from '/src/views/components/layout/LoginLayout';

export default {
  components: {
    DefaultLayout,
    LoginLayout
  },
  methods: {
    layout() {
      // router.jsのroutesにmeta.layoutの存在確認
      // セットするレイアウトを判断する
      return this.$route.meta.layout ? this.$route.meta.layout + '-layout' : 'default-layout';
    }
  },
}
</script>
